import { Box } from '@mantine/core';

import { useGetColor } from 'hooks';

import type { IconPropsType } from './types';

export const TableStaticIcon = ({
  color,
  size = 24,
  sx,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.42857 6.28571H6.28571C5.65453 6.28571 5.14285 6.79739 5.14285 7.42857V18.8571C5.14285 19.4883 5.65453 20 6.28571 20H15.4286C16.0597 20 16.5714 19.4883 16.5714 18.8571V17.7143M17.7143 17.7143H8.57142C7.94024 17.7143 7.42857 17.2026 7.42857 16.5714V5.14286C7.42857 4.51167 7.94024 4 8.57142 4H15.4286L18.8571 6.28571V16.5714C18.8571 17.2026 18.3455 17.7143 17.7143 17.7143Z"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M10.2 10H13.2M13.2 10V8M13.2 10V12M13.2 10H14.7H16.2M16.2 10V9.5C16.2 8.67157 15.5284 8 14.7 8H11.7C10.8716 8 10.2 8.67157 10.2 9.5V12.5C10.2 13.3284 10.8716 14 11.7 14H14.7C15.5284 14 16.2 13.3284 16.2 12.5V10ZM10.5 12H13.2M13.2 12H16.2M13.2 12V13.8125"
        stroke={iconColor}
      />
    </Box>
  );
};
